import { render, staticRenderFns } from "./custom-switch.vue?vue&type=template&id=181e00e6&scoped=true&"
import script from "./custom-switch.vue?vue&type=script&lang=js&"
export * from "./custom-switch.vue?vue&type=script&lang=js&"
import style0 from "./custom-switch.vue?vue&type=style&index=0&id=181e00e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e00e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
